export const galleryContainerAnim = {
  hidden: {
    opacity: 0,
  },
  show: {
    opacity: 1,
  },
  exit: {
    opacity: 0,
  },
};

export const searchModalAnim = {
  hidden: {
    y: 50,
    opacity: 0,
  },
  show: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.3,
      staggerChildren: 0.2,
    },
  },
};

export const bookingAnim = {
  hidden: {
    height: 0,
    opacity: 0,
  },
  show: {
    opacity: 1,
    height: "auto",
    transition: {
      type: "spring",
    },
  },
  exit: {
    y: -10,
    height: 0,
    opacity: 0,
    transition: {
      delay: 0.1,
      duration: 0.2,
    },
  },
};

export const bookingArrowAnim = {
  hidden: {
    rotate: 0,
  },
  show: {
    rotate: -180,
    transition: {
      type: "spring",
    },
  },
};

export const videoModalAnim = {
  hidden: {
    y: "-100vh",
    opacity: 0,
  },
  show: {
    y: "0",
    opacity: 1,
    transition: {
      delay: 0.1,
      // type: "linear",
    },
  },
  exit: {
    y: "100vh",
    opacity: 0,
    transition: {
      duration: 0.5,
    },
  },
};

export const bookingModalAnim = {
  hidden: {
    y: -50,
    opacity: 0,
  },
  show: {
    y: 0,
    opacity: 1,
    transition: {
      delay: 0.1,
      // type: "linear",
    },
  },
  exit: {
    y: -20,
    opacity: 0,
    transition: {
      duration: 0.5,
    },
  },
};
